export const headerDate = [
  {
    name: "12 AM",
  },
  {
    name: "01 AM",
  },
  {
    name: "02 AM",
  },
  {
    name: "03 AM",
  },
  {
    name: "04 AM",
  },
  {
    name: "05 AM",
  },
  {
    name: "06 AM",
  },
  {
    name: "07 AM",
  },
  {
    name: "08 AM",
  },
  {
    name: "09 AM",
  },
  {
    name: "10 AM",
  },
  {
    name: "11 AM",
  },
  {
    name: "12 PM",
  },
  {
    name: "01 PM",
  },
  {
    name: "02 PM",
  },
  {
    name: "03 PM",
  },
  {
    name: "04 PM",
  },
  {
    name: "05 PM",
  },
  {
    name: "06 PM",
  },
  {
    name: "07 PM",
  },
  {
    name: "08 PM",
  },
  {
    name: "09 PM",
  },
  {
    name: "10 PM",
  },
  {
    name: "11 PM",
  },
];